import React from 'react'
import PropTypes from 'prop-types'
import _filter from 'lodash/filter'

export default class extends React.PureComponent {
  static defaultProps = {
    onChange: () => {}
  }

  static propTypes = {
    defaultValue: PropTypes.array,
    name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onChange: PropTypes.func,
  }

  state = { values: this.props.defaultValue || [] }

  componentDidUpdate() {
    this.props.onChange(this.state.values)
  }

  get value() {
    const values = this.state.values.filter(value => !!value)
    this.setState({ values })
    return values
  }

  set value(values) {
    const state = { values }
    if (!Array.isArray(values)) {
      state.values = [values]
    }
    state.values = state.values.filter(value => !!value)
    this.setState(state)
  }

  onInputChange(index, e) {
    const values = this.state.values
      .map((value, key) => key === index ? e.target.value : value)
    this.setState({ values })
  }

  onAdd() {
    const values = this.state.values.concat([''])
    this.setState({ values })
  }

  onRemove(index) {
    const values = _filter(this.state.values, (value, key) => key !== index)
    this.setState({ values })
  }

  render() {
    const { name } = this.props

    return (
      <div className="inputs-collection text-right">
        {
          this.state.values.map((value, index) =>
            (<div key={index} className="form-group">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  value={value}
                  name={name}
                  onChange={ this.onInputChange.bind(this, index) }
                />
                <span className="input-group-btn">
                  <button
                    className="btn btn-secondary btn-sm"
                    type="button"
                    onClick={ this.onRemove.bind(this, index) } >
                    <i className="zmdi zmdi-minus mr-0" />
                  </button>
                </span>
              </div>
            </div>)
          )
        }
        <button
          className="btn btn-default btn-sm"
          type="button"
          onClick={ this.onAdd.bind(this) } >
          +
        </button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/sites/inputs-collection.js